<template>
  <div class="page-container">
    <section class="mt-10 mb-10">
      <h1 class="font-size--24 text-center" style="word-break: keep-all">
        중복된 정보를 확인하고 있습니다.<br />
        운영팀 확인 후<br />
        서비스 신청이 가능합니다.
      </h1>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('signup', ['signUpErrorRecords']),
  },
  watch: {
    signUpErrorRecords: {
      async handler() {
        if (this.signUpErrorRecords.length === 0) {
          return
        }
        if (
          this.signUpErrorRecords.filter((record) =>
            ['pending', 'in_progress'].includes(record.status),
          ).length === 0
        ) {
          await this.signout()
          await this.$router.push({ name: 'main' })
        }
      },
    },
  },
  methods: {
    ...mapActions('auth', ['signout']),
  },
}
</script>
